module.exports = __webpack_public_path__ + "static/media/stage3.4b65ef5a.svg";